'use client'
import { twMerge } from 'tailwind-merge'

import Button from '@/components/ui/CustomButton'

interface Props {
  className?: string
  pageType?: string
  date?: Date
  time?: [Date, Date]
  dateString?: string
  timeZone?: string
}
const bgColorMapping: { [key: string]: { dateBox: string; button: string } } = {
  live: {
    dateBox: 'bg-[#FFFBF5]',
    button: 'bg-[#FFF6EA]',
  },
  cancelled: {
    dateBox: 'bg-[#F8F8F8]',
    button: 'bg-[#E7E7E7]',
  },
  default: {
    dateBox: 'bg-[#F8F8F8]',
    button: 'bg-[#E7E7E7]',
  },
  payment: {
    dateBox: 'bg-[#F2F9FF]',
    button: 'bg-[#DFE8FF]',
  },
}
export default function DateBox(props: Props) {
  const timeZone = props.timeZone || 'Europe/London'
  let getDate
  if (props.dateString) getDate = new Date(props.dateString)
  // console.log("This is props:",props.className);

  const pageType: string = props.pageType || 'default'
  const { dateBox: bgDateBox, button: bgButton } = bgColorMapping[pageType]

  const formatInTZ = (date: Date, options: Intl.DateTimeFormatOptions) =>
    new Intl.DateTimeFormat(undefined, { timeZone, ...options }).format(date)

  const startDate: Date | undefined = props.date || getDate
  const startTime: Date | undefined = props.time?.[0]
  const endTime: Date | undefined = props.time?.[1]

  const time =
    startTime instanceof Date && endTime instanceof Date
      ? `${formatInTZ(startTime, { hour: '2-digit', minute: '2-digit', hour12: true })} - ${formatInTZ(endTime, { hour: '2-digit', minute: '2-digit', hour12: true })}`
      : undefined

  return (
    <div
      className={twMerge([
        `
          w-full rounded-md

          ${bgDateBox}

          flex h-max flex-col gap-6 p-

          md:flex-row md:items-center border border-[#F59405] bg-white
        `,
        props.className,
      ])}
      style={{ height: 'max-content' }}
    >
      <div className='flex flex-row justify-evenly gap-4'>
        <h1 className='md:text-3xl text-2xl font-semibold text-black mt-1'>
          {(startDate && formatInTZ(startDate, { day: '2-digit' })) || '02'}
        </h1>
        <p className='font-light md:text-base text-xs'>
          {(startDate && formatInTZ(startDate, { year: 'numeric' })) || '2023'} <br />
          {(startDate && formatInTZ(startDate, { month: 'long' })) || 'September'}
        </p>
      </div>
      <Button
        label={time ? time : 'Select a Time'}
        className={`
          h-10 w-auto rounded-md

          ${bgButton}

          flex items-center justify-center p-3  text-black font-light md:text-base text-xs bg-[#F1F5F7] 
        `}
      />
    </div>
  )
}
